import { gql } from '@apollo/client';

export const amenitiesQuery = gql`
  query SpaceAmenities {
    amenities {
      id
      name
      slug
      description
      icon
    }
  }
`;

export const locationSearchQuery = gql`
  query LocationSearch($query: String!) {
    locationSearch(query: $query) {
      id
      locationQuery
      bounds {
        swLat
        swLng
        neLat
        neLng
      }
    }
  }
`;

export const searchMarketplaceSpacesQuery = gql`
  query MarketplaceSpaceSearch(
    $swLat: Float
    $swLng: Float
    $neLat: Float
    $neLng: Float
    $first: Int
    $after: String
  ) {
    marketplaceSpaceSearch(
      swLat: $swLat
      swLng: $swLng
      neLat: $neLat
      neLng: $neLng
    ) {
      id
      paginatedSpaces(first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            name
            description
            displayInDirectory
            seated
            standing
            slug
            type
            pathname
            images(limit: 1) {
              id
              url
              filename
            }
            venue {
              id
              name
              slug
              type
              liveAvailability
              priceCategory
              expressBookSettings {
                minLeadTimeDays
                maxLeadTimeDays
                minEventDurationHours
                maxEventDurationHours
                minBufferTimeHours
              }
              hoursOfOperation {
                dayOfWeek
                isOpen
                startTime
                endTime
              }
              address {
                id
                streetAddress1
                streetAddress2
                city
                state
                latitude
                longitude
              }
              googlePlaceInfo {
                id
                rating
                reviewCount
                mapsUrl
              }
            }
            expressBookEnabled
            effectiveExpressBookSettings {
              minLeadTimeDays
              maxLeadTimeDays
              minEventDurationHours
              maxEventDurationHours
              minBufferTimeHours
            }
            bookingWindows {
              dayOfWeek
              startOffset
              endOffset
            }
            unavailableTimeSlots(startDate: null, endDate: null) {
              id
              date
              startOffset
              endOffset
            }
            amenities {
              id
              name
              slug
              description
              icon
            }
          }
        }
      }
    }
  }
`;
